import { render } from "./tickets-grid.vue?vue&type=template&id=fd5309e0"
import script from "./tickets-grid.vue?vue&type=script&lang=js"
export * from "./tickets-grid.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__